<wo-details-box
  [primary]="site"
  [secondary]="serviceLocation"
/>
